import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const getToken = () => localStorage.getItem("rg2k_token");
export const setToken = (t) => (t ? localStorage.setItem("rg2k_token", t) : localStorage.removeItem("rg2k_token"));

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export function fileUrl(url) {
  if (!url) return "";
  if (!url.startsWith("/api/")) return url;
  const t = getToken();
  return `${BACKEND}${url}${t && url.includes("/private/") ? `?auth=${t}` : ""}`;
}

export async function uploadFile(file, { scope = "private", convId, orderId } = {}) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("scope", scope);
  if (convId) fd.append("conv_id", convId);
  if (orderId) fd.append("order_id", orderId);
  const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}

export async function streamSSE(path, body, onDelta) {
  const t = getToken();
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...(t ? { Authorization: `Bearer ${t}` } : {}) },
    body: JSON.stringify(body),
  });
  if (!res.ok || !res.body) throw new Error("Request failed");
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  let final = {};
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const ev = JSON.parse(p.slice(6));
      if (ev.delta) onDelta(ev.delta);
      if (ev.done || ev.error) final = { ...final, ...ev };
    }
  }
  return final;
}

export const fmtDate = (s) => (s ? new Date(s).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : "");
export const fmtTime = (s) => (s ? new Date(s).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "");
export const label = (s) => (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
